import type { FilterShipmentsDescription } from "@/Shared/ShipmentFilter/Dialogs/Internal/FilterShipmentsDialogBody";

export function shipmentFilterEmptyDescription(): FilterShipmentsDescription {
  return {
    proNumber: undefined,
    bolNumber: undefined,
    carrierIdentifier: undefined,
    minPriceDollars: undefined,
    maxPriceDollars: undefined,
    shipmentState: undefined,
    pickupReferenceNumber: undefined,
    pickupBusinessName: undefined,
    pickupPostalCode: undefined,
    pickupStateOrProvinceCode: undefined,
    deliveryReferenceNumber: undefined,
    deliveryBusinessName: undefined,
    deliveryPostalCode: undefined,
    deliveryStateOrProvinceCode: undefined,
    bookedAtStartRange: undefined,
    bookedAtEndRange: undefined,
    pickupDateStartRange: undefined,
    pickupDateEndRange: undefined,
    deliveredAtStartRange: undefined,
    deliveredAtEndRange: undefined,
    onlyShowFreightClaims: undefined,
  };
}
